import { render } from "./TagRoleFilterModal.vue?vue&type=template&id=c99cb49a&scoped=true"
import script from "./TagRoleFilterModal.vue?vue&type=script&lang=js"
export * from "./TagRoleFilterModal.vue?vue&type=script&lang=js"

import "./TagRoleFilterModal.vue?vue&type=style&index=0&id=c99cb49a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c99cb49a"]])

export default __exports__